import { generateAndCopyShareLink, openShareDecryptUrl } from '../utils/shareLinkFlow';
import { sharePlaintextForAdHoc } from '../utils/sharePayload';

/** Tools screen: encrypt arbitrary text and copy a link (same crypto as page/item share). */
export class ShareEncryptToolView {
  render(container: HTMLElement): void {
    container.innerHTML = `
      <div class="share-encrypt-tool">
        <header class="share-encrypt-tool-header">
          <h2 class="file-title">Encrypt link</h2>
          <p class="share-encrypt-tool-lead">
            Paste or type text, set a passphrase, and copy an encrypted link. Nothing is saved to GitHub.
          </p>
        </header>
        <form class="share-encrypt-tool-form" id="share-encrypt-form">
          <label class="share-encrypt-label" for="share-encrypt-title">Title (optional)</label>
          <input
            type="text"
            id="share-encrypt-title"
            class="share-encrypt-input"
            maxlength="120"
            placeholder="e.g. Wi‑Fi password"
            autocomplete="off"
          />
          <label class="share-encrypt-label" for="share-encrypt-body">Text to encrypt</label>
          <textarea
            id="share-encrypt-body"
            class="share-encrypt-textarea"
            rows="14"
            placeholder="Enter the text you want to share securely…"
            spellcheck="true"
          ></textarea>
          <div class="share-encrypt-actions">
            <button type="submit" class="btn-primary" id="share-encrypt-submit">
              Generate encrypted link
            </button>
            <button type="button" class="btn-ghost-dark" id="share-encrypt-open" disabled title="Generate a link first">
              Open decrypt screen
            </button>
            <button type="button" class="btn-ghost-dark" id="share-encrypt-clear">Clear</button>
          </div>
          <p class="share-encrypt-hint text-muted small" id="share-encrypt-hint">
            Copied links open at this site with the same decrypt screen as page and item share links.
          </p>
        </form>
      </div>
    `;

    const form = container.querySelector<HTMLFormElement>('#share-encrypt-form')!;
    const titleInput = container.querySelector<HTMLInputElement>('#share-encrypt-title')!;
    const bodyInput = container.querySelector<HTMLTextAreaElement>('#share-encrypt-body')!;
    const openBtn = container.querySelector<HTMLButtonElement>('#share-encrypt-open')!;
    let lastUrl: string | null = null;

    container.querySelector('#share-encrypt-clear')!.addEventListener('click', () => {
      titleInput.value = '';
      bodyInput.value = '';
      lastUrl = null;
      openBtn.disabled = true;
      bodyInput.focus();
    });

    openBtn.addEventListener('click', () => {
      if (lastUrl) openShareDecryptUrl(lastUrl);
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      void (async () => {
        const result = await generateAndCopyShareLink(
          sharePlaintextForAdHoc(bodyInput.value, titleInput.value || 'Shared note')
        );
        if (result?.url) {
          lastUrl = result.url;
          openBtn.disabled = false;
        }
      })();
    });

    bodyInput.focus();
  }
}
